import { BTC_TOKENS, ETH_TOKENS, EURO_COINS, STABLE_COINS } from '@vaultsfyi/common/constants'
import type { Asset } from '@vaultsfyi/common/types'

export const getGroupedTokens = (tokens: Array<Asset['symbol']>) => {
  const ethTokens = tokens.filter((token) => ETH_TOKENS.includes(token))
  const stableCoins = tokens.filter((token) => [...STABLE_COINS, ...EURO_COINS].includes(token))
  const usdCoins = tokens.filter((token) => STABLE_COINS.includes(token))
  const euroCoins = tokens.filter((token) => EURO_COINS.includes(token))
  const btcCoins = tokens.filter((token) => BTC_TOKENS.includes(token))
  const otherTokens = tokens.filter(
    (token) => ![...ETH_TOKENS, ...STABLE_COINS, ...EURO_COINS, ...BTC_TOKENS].includes(token)
  )

  return {
    ethTokens,
    stableCoins,
    usdCoins,
    euroCoins,
    btcCoins,
    otherTokens,
  }
}
